// extracted by mini-css-extract-plugin
export var modal = "_c5-0";